export default __webpack_public_path__ + "static/media/redirect.57ed6aaf.svg";